import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarPointSummarySchema } from '../schemas';

export const searchGrammarPointsV1ResponseSchema = createApiResponseSchema(
  z.array(grammarPointSummarySchema),
) as z.ZodSchema<IAPI<z.infer<typeof grammarPointSummarySchema>[]>>;

export type ISearchGrammarPointsV1Response = IAPI<z.infer<typeof grammarPointSummarySchema>[]>;
